@if (visible) {
  <button
    type="button"
    pButton
    pRipple
    (click)="onAddColumnClick()"
    pTooltip="Add Column"
    tooltipPosition="bottom"
    aria-label="Add Column"
    class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
    <span class="material-symbols-outlined">splitscreen_vertical_add</span>
  </button>
}
